import { PartyPopper } from 'lucide-react'
import { useState } from 'react'
import { useNotification } from '../contexts/NotificationContext'
import { KUDOS } from '../lib/kudos'
import { sendGroupKudos } from '../services/groupService'
import { Button } from './ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'

// Preset kudos for one group member. Lands in their bell and the group's
// activity feed; the server caps how many a person sends per day.
export default function KudosMenu({ groupId, recipientId, recipientName, onSent }) {
  const notify = useNotification()
  const [sending, setSending] = useState(false)

  const send = async (kudos) => {
    setSending(true)
    try {
      const result = await sendGroupKudos({ groupId, recipientId, kudosKey: kudos.key })
      const left = result?.remaining_today
      notify.success(`${kudos.emoji} Sent to ${recipientName || 'them'}${
        typeof left === 'number' ? ` · ${left} left today` : ''}`)
      onSent?.()
    } catch (err) {
      console.error('Error sending kudos:', err)
      notify.error(err.message || 'Failed to send kudos')
    } finally {
      setSending(false)
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" disabled={sending} aria-label={`Send kudos to ${recipientName || 'member'}`}>
          <PartyPopper className="h-4 w-4 mr-1.5" />
          Kudos
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Send {recipientName ? recipientName.split(' ')[0] : 'them'} kudos</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {KUDOS.map((k) => (
          <DropdownMenuItem key={k.key} onSelect={() => send(k)}>
            <span className="mr-2" aria-hidden="true">{k.emoji}</span>
            {k.text}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
